// #genai
import React from 'lib/react';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import {
  EVButton,
  EVDialog,
  EVDialogActions,
  EVDialogContent,
  EVDialogContentText,
  EVDialogTitle,
} from 'lib/components';
import SaveDisclaimerDialogStyles from './SaveDisclaimerDialogStyles';

function SaveDisclaimerDialog({
  open,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  const classes = SaveDisclaimerDialogStyles();

  return (
    <EVDialog
      open={open}
      onClose={onCancel}
      classes={{ paper: classes.dialog }}
    >
      <EVDialogTitle disableTypography className={classes.title}>
        {t('billing_information__save_disclaimer_title')}
      </EVDialogTitle>
      <EVDialogContent>
        <EVDialogContentText className={classes.contentText}>
          {t('billing_information__save_disclaimer_message')}
        </EVDialogContentText>
      </EVDialogContent>
      <EVDialogActions className={classes.actions}>
        <EVButton
          onClick={onCancel}
          color="primary"
          variant="outlined"
          id="save-disclaimer-cancel-btn"
        >
          {t('billing_information__save_disclaimer_cancel')}
        </EVButton>
        <EVButton
          onClick={onConfirm}
          color="primary"
          variant="contained"
          id="save-disclaimer-confirm-btn"
        >
          {t('billing_information__save_disclaimer_confirm')}
        </EVButton>
      </EVDialogActions>
    </EVDialog>
  );
}

SaveDisclaimerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SaveDisclaimerDialog;
